<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.6 19.1996C15.4841 19.1992 16.9464 19.1787 17.8627 18.2624C18.8 17.3251 18.8 15.8166 18.8 12.7996V7.99805C18.6838 7.99968 18.5207 7.99965 18.4 7.99962H5.59995C5.47919 7.99965 5.31611 7.99968 5.19995 7.99805V12.7996C5.19995 15.8166 5.19995 17.3251 6.13721 18.2624C7.05352 19.1787 8.51583 19.1992 11.4 19.1996L11.4 13.5632L10.0459 15.0677C9.82426 15.314 9.44488 15.3339 9.19858 15.1123C8.95227 14.8906 8.9323 14.5112 9.15398 14.2649L11.554 11.5982C11.6678 11.4718 11.8299 11.3996 12 11.3996C12.17 11.3996 12.3321 11.4718 12.4459 11.5982L14.8459 14.2649C15.0676 14.5112 15.0476 14.8906 14.8013 15.1123C14.555 15.3339 14.1757 15.314 13.954 15.0677L12.6 13.5632L12.6 19.1996Z" fill="#0068A1"/>
    <path opacity="0.5" d="M4 6.3998C4 5.64556 4 5.26843 4.23431 5.03412C4.46863 4.7998 4.84575 4.7998 5.6 4.7998H18.4C19.1542 4.7998 19.5314 4.7998 19.7657 5.03412C20 5.26843 20 5.64556 20 6.3998C20 7.15405 20 7.53118 19.7657 7.76549C19.5314 7.9998 19.1542 7.9998 18.4 7.9998H5.6C4.84575 7.9998 4.46863 7.9998 4.23431 7.76549C4 7.53118 4 7.15405 4 6.3998Z" fill="#0068A1"/>
  </svg>
</template>

<script>
export default {
  name: "archiveUp"
}
</script>

<style scoped>

</style>